import React from 'react';
import { useTranslation } from 'react-i18next';

const RoundHistory = ({ rounds }) => {
  const { t } = useTranslation();
  if (!rounds || rounds.length === 0) {
    return (
      <div className="round-history empty">
        <span className="no-rounds">{t('live.noRoundsYet')}</span>
      </div>
    );
  }

  return (
    <div className="round-history">
      <div className="rounds-row">
        {rounds.map((round, idx) => (
          <div
            key={idx}
            className={`round-icon ${round.winner_side?.toLowerCase() === 'ct' ? 'ct-win' : 't-win'}`}
            title={t('live.roundTooltip', { n: round.round, winner: round.winner })}
          >
            {round.round}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoundHistory;
